import { render, staticRenderFns } from "./SSSSSSalesControlTable.vue?vue&type=template&id=3fa9b90c&scoped=true&"
import script from "./SSSSSSalesControlTable.vue?vue&type=script&lang=js&"
export * from "./SSSSSSalesControlTable.vue?vue&type=script&lang=js&"
import style0 from "./SSSSSSalesControlTable.vue?vue&type=style&index=0&id=3fa9b90c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa9b90c",
  null
  
)

export default component.exports